<template>
  <div class="transportation-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="transportation-content">
      <h4 class="transportation-h4 indent" id="transportation-7">Marine</h4>
      <p class="transportation-p indent">Aluminium's use in marine applications can increase the speed and size of boats, yachts, ferries, and ships, while improving their fuel economy, seaworthiness, safety, reliability, maintenance costs.</p>
      <p class="transportation-p indent">In many cases, integrally stiffened and mechanically interlocked extrusions are used for decks, roofing and other structures with conventional welded extrusions and sheet used for hulls and framing. </p>
      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_6.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-8">Rail</h4>
      <p class="transportation-p indent">In passenger cars aluminium allows manufacturers to shave off a third of the weight compared to steel cars. In rapid transit and suburban rail systems where trains have to make a lot of stops, significant savings can be achieved as less energy is needed for acceleration and braking with aluminium cars. In addition, aluminium cars are easier to produce and contain significantly fewer parts.</p>
      <div class="transportation-img" :style="{backgroundImage: 'url(' + '/static/img/markets/transportation/img_7.jpg' + ')'}"></div>
      <h4 class="transportation-h4 indent" id="transportation-9">Truck &amp; Trailer (Commercial vehicles)</h4>
      <p class="transportation-p indent">Aluminium reduces dead vehicle weight. When transporting high- density freight, which usually saturates the maximum gross vehicle weight, aluminium allows the loading of more goods. This translates into additional income and/or better competitiveness while at the same time reducing CO2 emissions. </p>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["transportation-7", "Marine"],
        ["transportation-8", "Rail"],
        ["transportation-9", "Truck & Trailer"]
      ]
    };
  }
};
</script>

<style scoped>
.transportation-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.transportation-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.transportation-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.transportation-link {
  font-size: 19px;
  text-decoration: underline;
}
.transportation-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.transportation-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .transportation-content {
    width: 100%;
  }
  .transportation-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .transportation-link {
    font-size: 16px;
  }
  .transportation-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Transportation.vue